<footer>
  <hr class="tw-m-0" />
  <div class="tw-bg-bosch-white tw-flex tw-justify-between tw-py-2 sm-max:tw-flex-col">
    <div class="tw-flex tw-flex-wrap tw-text-bosch-s sm-max:tw-py-2">
      <span class="tw-px-4">{{ logo }}</span>
      <span class="tw-px-4">{{ 'footer.appVersion' | translate }}: {{ appVersion }}</span>
      <span class="tw-px-4">
        {{ 'footer.copyrights' | translate : { year: currentYear } }}
      </span>
    </div>
    <hr class="tw-mx-4 tw-my-2 tw-hidden sm-max:tw-block" />
    <div class="tw-px-4 tw-flex sm-max:tw-flex-col">
      <bosch-ui-link
        *ngFor="let item of footerConfig"
        [routerLink]="item.link"
        [type]="'integrated'"
        class="sm-min:tw-px-4 sm-min:last:tw-pr-0 sm-max:tw-py-2 sm-max:tw-px-0"
      >
        {{ item.translationKey | translate }}
      </bosch-ui-link>
    </div>
  </div>
</footer>
